import React, { useMemo } from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
import { useSoFormStepsState } from '../../SoForm.context';
import SoFormContainer from '../../components/layout/SoFormContainer';
import { WarningIcon } from 'refactored/ui/icons';
import { useSelector } from 'react-redux';
import { selectors as settingsSelectors } from 'state/settings';
import config from 'config';
import { useTranslation } from 'react-i18next';

const TempContainer = styled.div`
  width: 100%;
  display: flex;
  text-align: center;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;

const EmptyError = () => {
  const { t } = useTranslation('Catalog');

  return (
    <TempContainer>
      <WarningIcon />
      {t('configuration.errors.empty_fields')}
    </TempContainer>
  );
};

const CoverageLink = styled.a`
  color: var(--primary500);
  padding: 8px;
  /* border: 1px solid red; */
`;

const MultiLineErrorContainer = styled.div`
  /* border: 2px solid green; */
  height: 100%;
`;

const NoProductsForRouteError = () => {
  const { t } = useTranslation('Catalog');

  const country = useSelector(settingsSelectors.getCountry);
  const secondaryLink = useMemo(() => config.OFFER_LINKS[country], [country]);
  return (
    <MultiLineErrorContainer>
      <TempContainer>
        <WarningIcon />
        {t('configuration.errors.no_route')}
      </TempContainer>
      <CoverageLink target="_blank" href={secondaryLink} rel="noreferrer">
        {t('configuration.errors.view_coverage_area')}
      </CoverageLink>
    </MultiLineErrorContainer>
  );
};

const SoFormStepConfigurationError = ({ className }) => {
  const stepsState = useSoFormStepsState();

  const showRegularErrors =
    stepsState.configuration.showConfigurationErrors &&
    stepsState.configuration.errors.fieldsWithEmptyError.length > 0;

  const showNoProductsForRoute =
    stepsState.configuration.showNoProductsForRoute;

  const showErrors = showRegularErrors || showNoProductsForRoute;

  if (!showErrors) return <></>;

  return (
    <div className={className}>
      <SoFormContainer>
        {showRegularErrors ? <EmptyError /> : <NoProductsForRouteError />}
      </SoFormContainer>
    </div>
  );
};

SoFormStepConfigurationError.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormStepConfigurationError)`
  border-bottom: 4px solid var(--error700);
  background: white;
  width: 100%;
  margin-top: auto;
  text-align: center;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  padding: 12px 16px;
  padding-top: 0;
  color: #263340;
  /* Inside auto layout */

  text-align: center;

  svg {
    fill: var(--error700);
    path {
      fill: var(--error700);
    }
  }
`;
